import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "light", setTheme: () => {}, toggle: () => {} });

export const ThemeProvider = ({ children }) => {
    const [theme, setThemeState] = useState(() => {
        try { return localStorage.getItem("awc_theme") || "light"; }
        catch { return "light"; }
    });

    useEffect(() => {
        const root = document.documentElement;
        if (theme === "dark") root.classList.add("theme-dark");
        else root.classList.remove("theme-dark");
        try { localStorage.setItem("awc_theme", theme); } catch {}
    }, [theme]);

    const setTheme = (t) => setThemeState(t === "dark" ? "dark" : "light");
    const toggle = () => setThemeState((t) => (t === "dark" ? "light" : "dark"));

    return <ThemeContext.Provider value={{ theme, setTheme, toggle }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
